<div class="pt-2">
    <div class="search-box">
        <div class="col-auto p-0 mt-4">
            <app-bd-search (searchTextChanged)="onSearchTextChanged($event)"></app-bd-search>
        </div>
    </div>

    <div class="col-12 static-card">
        <bd-light-table 
            [gridData]="gridData || [] | search:searchText:['chcImportType','chcImportId','chcImportStatus','chcImportDateTime']"
            [pageInfo]="pageInfo" [fields]="fields" [actionsLast]=true [actions]="actionItems"></bd-light-table>
    </div>


</div>

<ng-template #delmodal>
    <div class="modal-header justify-content-between align-items-center">
        <h5 class="modal-title">{{'AUTHORIZATION.CONFIRMATION' | translate}}</h5>
        <a class="cursor" data-dismiss="modal" (click)="modalRef.hide()"><img
                src="assets/ph-bhp-layout/svg/remove.svg"></a>
    </div>
    <div class="modal-body" data-simplebar>
        <p class="text-center">
            {{'WEBKESS_INTEGRATION.DELETE_RECORD' | translate}}
        </p>
    </div>
    <div class="modal-footer">
        <div class="container-fluid">
            <div class="row">
                <div class="col my-3 justify-content-center align-items-center d-flex">
                    <button (click)="modalRef.hide()" class="btn btn-cancel mr-4">{{'AUTHORIZATION.CANCEL' |translate}}</button>
                    <button (click)="delete();modalRef.hide()" class="btn btn-primary">{{'LAYOUT_MODULE.DELETE' |
                        translate}}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>